import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

const STATS = [
  { value: 15, suffix: "+", label: "Years building" },
  { value: 240, suffix: "+", label: "Projects delivered" },
  { value: 98, suffix: "%", label: "On-time handover" },
  { value: 100, suffix: "%", label: "Safety compliance" },
];

const Counter = ({ target, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let raf;
    const start = performance.now();
    const dur = 1600;
    const tick = (t) => {
      const p = Math.min((t - start) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.round(eased * target));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, target]);

  return (
    <span ref={ref}>
      {n}
      {suffix}
    </span>
  );
};

export const Stats = () => {
  return (
    <section className="bg-surface border-y border-line" data-testid="stats">
      <div className="mx-auto max-w-[1600px] grid grid-cols-2 lg:grid-cols-4">
        {STATS.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.08 }}
            className="border-r border-line last:border-r-0 [&:nth-child(2)]:border-r-0 lg:[&:nth-child(2)]:border-r p-8 md:p-14"
            data-testid={`stat-${i}`}
          >
            <div className="font-heading font-black tracking-tighter text-5xl md:text-7xl text-flame leading-none">
              <Counter target={s.value} suffix={s.suffix} />
            </div>
            <p className="mt-4 text-secondary-foreground/75 uppercase tracking-widest text-xs md:text-sm">{s.label}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
